import React from "react";
import {
  Blocks,
  Building2,
  GraduationCap,
  Landmark,
  Network,
  Store,
  UsersRound,
} from "lucide-react";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const clientTypes = [
  {
    icon: Building2,
    title: "Entreprises",
    example: "Encaissement et paiements fournisseurs",
  },
  {
    icon: Landmark,
    title: "Institutions",
    example: "Paiements de bénéficiaires et suivi",
  },
  {
    icon: GraduationCap,
    title: "Écoles et universités",
    example: "Paiement des frais scolaires",
  },
  { icon: Store, title: "Marchands", example: "Encaissement mobile" },
  { icon: Blocks, title: "Développeurs", example: "Intégration API" },
  {
    icon: UsersRound,
    title: "Organisations et projets",
    example: "Paiements en masse",
  },
  {
    icon: Network,
    title: "Services publics",
    example: "Parcours de paiement adaptés",
  },
];

const HomeClientTypes = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-section ws-section--soft"
      aria-labelledby="ws-home-clients-title"
    >
      <div className="ws-shell">
        <RevealOnScroll className="ws-section-heading">
          <span className="ws-kicker">{t("Pour chaque organisation")}</span>
          <h2 id="ws-home-clients-title">
            {t("Des solutions pensées pour vos usages")}
          </h2>
          <p>
            {t(
              "WonyaSoft adapte ses parcours aux réalités opérationnelles de plusieurs secteurs.",
            )}
          </p>
        </RevealOnScroll>

        <div className="ws-home-client-grid">
          {clientTypes.map(({ icon: Icon, title, example }, index) => (
            <RevealOnScroll
              as="article"
              className="ws-home-client-card"
              delay={(index % 4) * 70}
              key={title}
              variant="scale-in"
            >
              <Icon size={23} aria-hidden="true" />
              <div>
                <h3>{t(title)}</h3>
                <p>{t(example)}</p>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeClientTypes;
